import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ContentBlock } from 'src/uikit/ContentBlock';
import { CustomCard } from 'src/components/MainPage/_shared/CustomCard';
import { WarehouseIncomeDetail } from '../WarehouseIncomesPage/services';
import { useWarehouseIncomesData } from '../WarehouseIncomesPage/hooks/useWarehouseIncomesData';
import {
  formatDocumentDate,
  getEnumDescription,
  findNameById,
} from '../WarehouseIncomesPage/helpers';
import { ItemsReadonlyTable } from './components/ItemsReadonlyTable';

type Props = {
  data: WarehouseIncomeDetail;
};

export const WarehouseIncomeContent = ({ data }: Props) => {
  const { types, statuses, warehouses, suppliers } = useWarehouseIncomesData();

  const typeDescription = getEnumDescription(types, data.type);
  const statusDescription = getEnumDescription(statuses, data.status);
  const warehouseName = findNameById(warehouses, data.warehouseId);
  const supplierName = findNameById(suppliers, data.supplierId);

  return (
    <Stack gap={3}>
      <CustomCard
        header={<Typography p={2}>Данные о приёмке</Typography>}
        body={
          <Stack gap={[4, 4, 6]} p={2}>
            <Stack gap={[4, 4, 6]} sx={{ flexDirection: { md: 'row' } }}>
              <Stack
                gap={3}
                flex={1}
                flexWrap="wrap"
                sx={{ flexDirection: { md: 'row' } }}
              >
                <ContentBlock
                  label="Номер акта"
                  content={data.number}
                  flex={1}
                />
                <ContentBlock
                  label="Тип акта"
                  content={typeDescription}
                  flex={1}
                />
                <ContentBlock
                  label="Статус"
                  content={statusDescription}
                  flex={1}
                />
              </Stack>
              <Stack
                gap={3}
                flex={1}
                flexWrap="wrap"
                sx={{ flexDirection: { md: 'row' } }}
              >
                <ContentBlock
                  label="Дата и время приёмки"
                  content={formatDocumentDate(data.timeStamp)}
                  flex={1}
                />
                <ContentBlock
                  label="Создан"
                  content={formatDocumentDate(data.createdAt)}
                  flex={1}
                />
              </Stack>
            </Stack>

            <Stack gap={[4, 4, 6]} sx={{ flexDirection: { md: 'row' } }}>
              <ContentBlock label="Склад" content={warehouseName} flex={1} />
              <ContentBlock label="Поставщик" content={supplierName} flex={1} />
              <ContentBlock
                label="Комментарий"
                content={data.comment || '—'}
                flex={1}
              />
            </Stack>
          </Stack>
        }
      />

      <CustomCard
        header={<Typography p={2}>Номенклатуры</Typography>}
        body={<ItemsReadonlyTable items={data.items} />}
      />
    </Stack>
  );
};
